import React, { Fragment } from 'react'
import { object, array, func, string, bool } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../utils/constants'
import List from '../../ui/list/List'
import VirtualizedList from '../../ui/list/VirtualizedList'

// use constants
const getOneColumnMessage = (itemType, activeSearch) => {
  switch (itemType) {
    case 'categories':
      return 'allCategories'
    case 'companies':
      return 'allCompanies'
    case 'offices':
      return activeSearch ? 'alphabetically' : 'mostPopular'
    default:
      return 'allResults'
  }
}

const BigList = ({
  messages = EMPTY_OBJECT,
  mostPopularFiltered = EMPTY_ARRAY,
  onClickItem,
  filteredData = EMPTY_ARRAY,
  renderNoMatchQuery,
  isOneColumnType = '',
  activeSearch = false,
  site = 'us'
}) => (
  <Fragment>
    {!isOneColumnType && <div className='ad-filter__content--single ad-filter__content--single-large'>
      <span className='ad-filter__title'><FormattedMessage {...messages.mostPopular} /></span>
      {mostPopularFiltered.length > 0
        ? (<List onClick={onClickItem} isInnerHtml items={mostPopularFiltered} />)
        : <div className='ad-filter__text'>{renderNoMatchQuery}</div>}
    </div>}
    <div className='ad-filter__content--full'>
      <span className='ad-filter__title'>
        <FormattedMessage
          {...(isOneColumnType ? messages[getOneColumnMessage(isOneColumnType, activeSearch)] : messages.alphabetically)}
        />
      </span>
      {
        <VirtualizedList
          onClick={onClickItem}
          isInnerHtml
          items={isOneColumnType === 'offices' && !activeSearch ? mostPopularFiltered : filteredData}
        />
      }
    </div>
  </Fragment>
)

BigList.propTypes = {
  messages: object,
  mostPopularFiltered: array,
  onClickItem: func,
  filteredData: array,
  renderNoMatchQuery: object,
  isOneColumnType: string,
  activeSearch: bool,
  site: string
}

export default BigList